import { Component, OnInit, Input } from '@angular/core';
import { HeaderConnectionErrorService } from './header-connection-error.service';
import { trigger, state, style, transition, animate } from '@angular/animations';
@Component({
  selector: 'app-header-connection-error',
  templateUrl: './header-connection-error.component.html',
  styleUrls: ['./header-connection-error.component.scss'],
  animations: [
    trigger('showConnectionError', [
      state('show', style({
        display: 'flex'
      })),
      state('hide', style({
        display: 'none'
      })),
      transition('show => hide', animate('100ms ease-in')),
      transition('hide => show', animate('100ms ease-out'))
  ])]
})
export class HeaderConnectionErrorComponent implements OnInit {

  @Input() sidenavWidth;
  state: string;

  constructor(private headerConnectionErrorService: HeaderConnectionErrorService) {
    this.state = 'hide';
  }

  ngOnInit() {
    this.headerConnectionErrorService.connectionErrorListen().subscribe(
        (res) => {
          if (res) {
            this.state = 'show';
          } else {
            this.state = 'hide';
          }
        }
    );
  }

}
